import Box from '@mui/material/Box';
import * as React from 'react';

interface ITableItem {
  isActive: boolean;
  itemIcon?: React.ReactNode;
  itemText?: React.ReactNode;
}

function TableItem({ isActive, itemIcon, itemText }: ITableItem) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        color: isActive ? 'text.primary' : 'text.disabled',
        display: 'inline-flex',
      }}
    >
      {itemIcon && (
        <Box
          sx={{
            '& svg': { verticalAlign: 'middle' },
            color: isActive ? 'action.active' : 'action.disabled',
            pr: 2,
          }}
        >
          {itemIcon}
        </Box>
      )}
      {itemText && <Box sx={{ '& a': { color: 'inherit' } }}>{itemText}</Box>}
    </Box>
  );
}

export default TableItem;
